import script from "./FindPw.vue?vue&type=script&setup=true&lang=js"
export * from "./FindPw.vue?vue&type=script&setup=true&lang=js"

import "./FindPw.vue?vue&type=style&index=0&id=27e224b4&scope=true&lang=css"

const __exports__ = script;

export default __exports__